import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    flexDirection: "column",
    justifyContent: "space-between",
    ...shorthands.padding("10px", "13px", "10px", "16px"),
  },
  main: {
    flexDirection: "column",
    ...shorthands.gap("1px"),
    width: "100%",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    ...shorthands.padding("10px", "13px", "10px", "16px"),
  },
});
